<template>
  <div class="lesson_page flex-col">
    <StudentHeader
      :title="title"
      back-visibility="hidden"
    />
    <div class="content_container flex-col">
      <div class="lesson_content flex-col">
        <div class="header_section flex-row">
          <span class="course_title">课程目录</span>
          <div class="report_button flex-row justify-between">
            <img
              class="report_icon"
              referrerpolicy="no-referrer"
              src="../../assets/student/lesson/FigmaDDSSlicePNGdcfd15f719149f1885d3fe072da45850.png"
            />
            <span
              class="report_text"
              @click="LearnReport()"
              >表现报告</span
            >
          </div>
        </div>

        <div class="courses_list flex-row justify-between">
          <div class="courses_container flex-col justify-start">
            <div
              class="course_item flex-row justify-end"
              v-for="item in lists"
              @click="onClick(item.id, item.course_name)"
            >
              <div
                class="course_image_container flex-col"
                :style="{ backgroundImage: `url(${item.imgurl})` }"
              >
                <div class="difficulty_badge flex-col">
                  <div class="difficulty_background flex-col"></div>
                  <img
                    class="difficulty_icon"
                    referrerpolicy="no-referrer"
                    src="../../assets/student/lesson/FigmaDDSSlicePNG99222c51addfadd5bb3bb56e8a02c082.png"
                  />
                  <span class="difficulty_level">{{ item.diffcult_level }}</span>
                </div>
              </div>
              <div class="course_info flex-col justify-between">
                <div class="course_header flex-row">
                  <span class="course_name">{{ item.course_name }}</span>
                  <span class="course_details"
                    >课时：{{ item.course_count }}&nbsp;&nbsp;&nbsp;建议课时：{{
                      item.course_hour
                    }}分钟</span
                  >
                </div>
                <span class="course_description">
                  {{ item.description }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue"
import { useRouter } from "vue-router"

import alovaInstance from "@/utils/alova"
import StudentHeader from "@/components/StudentHeader.vue"

const router = useRouter()
const title = ref("课程")
const lists = ref([])

const fetchLessonData = async () => {
  try {
    const response = await alovaInstance.Post("/Course/GetCoursesInfo")
    if (response.code === 1000) {
      lists.value = response.data
      return
    }
  } catch (error) {
    console.error("获取课程数据失败:", error)
    alert("加载课程数据失败，请稍后重试")
  }
}

onMounted(() => {
  localStorage.setItem("title", "课程")
  fetchLessonData()
})

const onClick = (id, pageTitle) => {
  localStorage.setItem("title", pageTitle)
  router.push({
    name: "CourseList",
    query: { id: id },
  })
}
const LearnReport = () => {
  router.push({
    name: "LearnReport",
  })
}
</script>

<style src="@/assets/common.css" />
<style scoped>
.lesson_page {
  background-color: rgba(234, 238, 242, 1);
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.content_container {
  position: relative;
  width: 100%;
  height: calc(100vh - 2.87vw);
  margin-bottom: 0;
}

.courses_list {
  height: calc(100% - 6.2vw);
  overflow-y: auto;
  width: 72.45vw;
  margin: 1.45vw 0 4.94vw 2.08vw;
}

.lesson_content {
  box-shadow: 2px 2px 6px 3px rgba(12, 12, 13, 0.05);
  background-color: rgba(255, 255, 255, 1);
  border-radius: 32px;
  width: 75vw;
  height: calc(100% - 2.87vw);
  margin: 1.35vw auto 0;
}

.header_section {
  background-color: rgba(128, 174, 243, 1);
  border-radius: 32px 32px 0px 0px;
  width: 75vw;
  height: 2.87vw;
}

.course_title {
  width: 6.67vw;
  height: 2.19vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 1.5vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 1.67vw;
  margin: 0.5vw 0 0 34.16vw;
}

.report_button {
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  width: 7.45vw;
  height: 2.24vw;
  margin: 0.38vw 2.5vw 0 24.21vw;
  cursor: pointer;
}

.report_icon {
  width: 1.15vw;
  height: 1.25vw;
  margin: 0.52vw 0 0 0.83vw;
}

.report_text {
  width: 4.17vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 1.05vw;
  margin: 0.58vw 0.83vw 0 0;
}

.courses_container {
  width: 70.37vw;
  height: 100%;
}

.course_item {
  box-shadow: 2px 2px 6px 3px rgba(12, 12, 13, 0.05);
  background-color: rgba(243, 249, 255, 1);
  border-radius: 28px;
  width: 70.37vw;
  height: 11.46vw;
  margin-top: 0.2vw;
  margin-bottom: 1.45vw;
  cursor: pointer;
}

.course_image_container {
  height: 9.8vw;
  background-size: 100% 100%;
  width: 19.33vw;
  margin: 0.83vw 0 0 1.66vw;
  border-radius: 16px;
}

.difficulty_badge {
  background-color: rgba(243, 171, 69, 1);
  border-radius: 16px 0px 16px 0px;
  position: relative;
  width: 4.74vw;
  height: 9.8vw;
  z-index: 99;
}

.difficulty_background {
  background-color: rgba(255, 199, 136, 0.56);
  border-radius: 12px;
  width: 3.23vw;
  height: 2.56vw;
  margin: 2.91vw 0 0 0.72vw;
  z-index: 99;
}

.difficulty_icon {
  width: 2.56vw;
  height: 3.13vw;
  margin: 1.25vw 0 0.05vw 2.18vw;
  z-index: 99;
}

.difficulty_level {
  position: absolute;
  left: 1.36vw;
  top: 0.94vw;
  width: 1.98vw;
  height: 4.02vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 3.33vw;
  font-family: Mochiy Pop One-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 3.34vw;
  z-index: 99;
}

.course_info {
  width: 46.88vw;
  height: 9.43vw;
  margin-left: 2.5vw;
}

.course_header {
  width: 46.88vw;
  height: 3.03vw;
}

.course_name {
  width: 4.33vw;
  height: 2.19vw;
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 1);
  font-size: 1.66vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 1.67vw;
  margin-top: 0.84vw;
}

.course_details {
  width: 15.47vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(130, 130, 130, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin: 1.51vw 0 0 4.5vw;
}

.course_description {
  width: 46.88vw;
  height: 4.84vw;
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  line-height: 1.56vw;
  margin-top: 1.56vw;
}
</style>
